import gsap from 'gsap';
import EmitEvent, {PAGE_ENTER} from "../../../libs/emit-event";

export class Cookies {
    constructor() {
        this.DOM = {main: document.querySelector('.js-cookie-alert')};
        if (!this.DOM.main) return;

        this.DOM.btnClose = this.DOM.main.querySelector('.js-cookie-alert_close');
        this.isAccept = localStorage.getItem("accept_cookies");
        this.pageEnter = this.pageEnter.bind(this);
        if (!this.isAccept) {
            this.init();
            this.bindEvent();
        } else {
            this.DOM.main.remove();
        }
    }

    init() {
        EmitEvent.on(PAGE_ENTER, this.pageEnter);
    }

    pageEnter() {
        setTimeout(() => {
            this.DOM.main.classList.add('on-show');
        }, 400);
    }

    cookieAccept(event) {
        event.preventDefault();
        this.cookieIsClose = true;
        localStorage.setItem('accept_cookies', true);
        this.DOM.main.classList.remove('on-show');
        EmitEvent.off(PAGE_ENTER, this.pageEnter);
    }

    bindEvent() {
        this.DOM.btnClose.addEventListener('click', this.cookieAccept.bind(this));
    }
}
